(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-grid"] && !Shopify.designMode) return;
  try {
    
if (!window.hvCategoryGridFallbackReady) {
  window.hvCategoryGridFallbackReady = true;
  const showCategoryImageFallback = (image) => {
    const card = image.closest('.category-card');
    const fallback = card?.querySelector('.category-card__fallback');
    if (!card || !fallback) return;
    card.classList.add('category-card--image-error');
    fallback.hidden = false;
  };
  document.addEventListener('error', (event) => {
    const image = event.target;
    if (image instanceof HTMLImageElement && image.classList.contains('category-card__image')) showCategoryImageFallback(image);
  }, true);
  document.querySelectorAll('.category-card__image').forEach((image) => {
    if (image.complete && image.naturalWidth === 0) showCategoryImageFallback(image);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
const buyBar = document.querySelector('[data-mobile-buy]');
const mainBuy = document.querySelector('#hv-product-form button[type="submit"]');
if (buyBar && mainBuy && 'IntersectionObserver' in window) {
  const buyObserver = new IntersectionObserver(([entry]) => {
    buyBar.hidden = entry.isIntersecting;
  });
  buyObserver.observe(mainBuy);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spotlight-popups"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-product-spotlight-sequence]').forEach((root) => {
  const items = Array.from(root.querySelectorAll('[data-spotlight-item]'));
  if (!items.length) return;
  let index = 0;
  let timer;
  const visibleTime = Number(root.dataset.visible) || 6000;
  const gapTime = Number(root.dataset.gap) || 10000;
  const show = () => {
    items.forEach((item, itemIndex) => {
      item.hidden = itemIndex !== index;
      item.classList.toggle('is-visible', itemIndex === index);
    });
    timer = window.setTimeout(hide, visibleTime);
  };
  const hide = () => {
    items[index].classList.remove('is-visible');
    items[index].hidden = true;
    index = (index + 1) % items.length;
    timer = window.setTimeout(show, gapTime);
  };
  root.querySelectorAll('[data-spotlight-close]').forEach((close) => {
    close.addEventListener('click', () => {
      window.clearTimeout(timer);
      items[index].classList.remove('is-visible');
      items[index].hidden = true;
      index = (index + 1) % items.length;
      timer = window.setTimeout(show, gapTime);
    });
  });
  timer = window.setTimeout(show, Number(root.dataset.delay) || 5000);
});

  } catch(e) { console.error(e); }
})();
})();
